(function ($) {
  $(document).ready(function () {

    
    var deviceAgent = navigator.userAgent.toLowerCase();
    if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
        $("html").addClass("ios");
        $("html").addClass("mobile");
    }
    if (deviceAgent.match(/(Android)/)) {
        $("html").addClass("android");
        $("html").addClass("mobile");
    }
    if (navigator.userAgent.search("MSIE") >= 0) {
        $("html").addClass("ie");
    } else if (navigator.userAgent.search("Chrome") >= 0) {
        $("html").addClass("chrome");
    } else if (navigator.userAgent.search("Firefox") >= 0) {
        $("html").addClass("firefox");
    } else if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
        $("html").addClass("safari");
    } else if (navigator.userAgent.search("Opera") >= 0) {
        $("html").addClass("opera");
    }

    
    
    // Mobile Menu

    $('.troxy-burger-button').click (function(){
      $(this).toggleClass('js-open-burger');

      $('.troxy-navigation__links').toggleClass('mobile-open');

      if ($(this).attr('aria-pressed') == 'false') {
        $(this).attr('aria-pressed', 'true');
      } else {
        $(this).attr('aria-pressed', 'false');
      }

    });

  });

})(jQuery);



window.addEventListener('DOMContentLoaded',function(){

  // Lazy load footer background images
  const footer = document.querySelector('footer');

  const intersectionObserver = new IntersectionObserver((entries) => {
    // If intersectionRatio is 0, the target is out of view
    if (entries[0].intersectionRatio <= 0) return;
    // If footer is in view remove the troxy-no-bg-img class 
    document.querySelector('#troxy-footer-bg-img').classList.remove('troxy-no-bg-img');
  });
  // start observing
  intersectionObserver.observe(footer);
})


